import { AssessmentType, ExamType, StudentAssessmentType } from "../../types/Assessment";

  export const calculateFinalGradeV2 = (studentAssessments: StudentAssessmentType[], assessments:AssessmentType[]) => {
    if (!studentAssessments || studentAssessments.length === 0) {
      return 0;
    }

    const examAssessments = assessments.filter(a => ['Exame Normal', 'Exame de Recorrência', 'Exame Especial'].includes(a.type as ExamType));
    const nonExamAssessments = assessments.filter(a => !['Exame Normal', 'Exame de Recorrência', 'Exame Especial'].includes(a.type as ExamType));

    const nonExamGrade = nonExamAssessments.reduce((total, assessment) => {
      const studentAssessment = studentAssessments.find(sa => sa.idAssessment === assessment.id);
      const grade = studentAssessment?.grade ?? 0;
      const weight = assessment.weight ?? 0;
      return total + (grade * weight) / 100;
    }, 0);
    const examNormal = studentAssessments.find(sa => examAssessments.some(exam => exam.type === 'Exame Normal' && exam.id === sa.idAssessment))?.grade ?? 0;
    const examRecorrente = studentAssessments.find(sa => examAssessments.some(exam => exam.type === 'Exame de Recorrência' && exam.id === sa.idAssessment))?.grade ?? 0;
    const examEspecial = studentAssessments.find(sa => examAssessments.some(exam => exam.type === 'Exame Especial' && exam.id === sa.idAssessment))?.grade ?? 0;
    if (nonExamGrade > 13.5) {
        return nonExamGrade;
    } else if (nonExamGrade < 9.5) {
        if (examEspecial > 0) {
            return examEspecial;  
        } else if (examRecorrente > 0) {
            return examRecorrente;  
        } else if (examNormal > 0) {
            return examNormal;  
        } else {
            return nonExamGrade;  
        }
    } else if (nonExamGrade > 9.5 && nonExamGrade < 13.5) {
        if (examNormal >= 9.5) {
            return (nonExamGrade + examNormal) / 2;
        } else if (examRecorrente >= 9.5) {
            return (nonExamGrade + examRecorrente) / 2;
        } else if (examEspecial > 0) {
            return examEspecial; 
        } else {
            return nonExamGrade;  
        }
    } else {
        return nonExamGrade;
    }
};

  const calculateFinalGrade = (studentAssessments: StudentAssessmentType[], assessments:AssessmentType[]) => {
    if (!studentAssessments || studentAssessments.length === 0) {
      return 0;
    }

    const nonExamAssessments = assessments.filter(a =>
      a.type && !['Exame Normal', 'Exame de Recorrência', 'Exame Especial'].includes(a.type)
    );

    const totalGrade = nonExamAssessments.reduce((total, assessment) => {
      const studentAssessment = studentAssessments.find(sa => sa.idAssessment === assessment.id);
      const grade = studentAssessment?.grade ?? 0;
      const weight = assessment.weight ?? 0;
      return Math.round(total + (grade * weight) / 100);
    }, 0);

    return totalGrade;
  };